var Ribbon_default = {
  "ribbon": "_6tj5J",
  "ribbonText": "XFzu0",
  "imageRibbon": "DMNL6"
};
export {
  Ribbon_default as default
};
//# sourceMappingURL=Ribbon-scss.js.map
